import { minimumWidth, styled } from '@feast-it/ui/light';

export const Container = styled.div`
  ${({ theme }) => `
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing[4]};
        align-items: center;

        ${minimumWidth(theme.breakpoints.small)} {
            align-items: flex-start;
        }
    `};
`;

export const OptionsWrapper = styled.div`
  ${({ theme }) => `
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: ${theme.spacing[4]};

        ${minimumWidth(theme.breakpoints.small)} {
          justify-content: flex-start;
        }
    `};
`;
